// src/components/IntroPage/Navbar.js
import React from 'react';
import { Link } from 'react-router-dom';
import './IntroPage.css';  // contains .navbar, .nav-logo-link, .nav-links, etc.
import logo from "./Logo-removebg-preview.png"

const Navbar = () => (
  <nav className="navbar">
    <Link to="/" className="nav-logo-link">
      <img src= {logo} alt="VBADI Logo" className="nav-logo-img" />
    </Link>

    <ul className="nav-links">
      <li><Link to="/login">Login</Link></li>
    </ul>
  </nav>
);

export default Navbar;
